/** Lifecycle of a portal partner (venues use the full funnel; authors use registered/blocked). */
export enum PortalPartnerStatusEnum {
    NEW = 'new',
    INVITE_SENT = 'invite_sent',
    LANDING_OPENED = 'landing_opened',
    REGISTERED = 'registered',
    HAS_ORDERS = 'has_orders',
    CLOSED = 'closed',
    BLOCKED = 'blocked',
    REJECTED = 'rejected',
}
